import _classCallCheck from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React from 'react';
import { Animated, View, StyleSheet } from 'react-native';

var TabBarIcon =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TabBarIcon, _React$Component);

  function TabBarIcon() {
    _classCallCheck(this, TabBarIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(TabBarIcon).apply(this, arguments));
  }

  _createClass(TabBarIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          route = _this$props.route,
          activeOpacity = _this$props.activeOpacity,
          inactiveOpacity = _this$props.inactiveOpacity,
          activeTintColor = _this$props.activeTintColor,
          inactiveTintColor = _this$props.inactiveTintColor,
          renderIcon = _this$props.renderIcon,
          horizontal = _this$props.horizontal,
          style = _this$props.style; // We render the icon twice at the same position on top of each other:
      // active and inactive one, so we can fade between them.

      return React.createElement(View, {
        style: style
      }, React.createElement(Animated.View, {
        style: [styles.icon, {
          opacity: activeOpacity
        }]
      }, renderIcon({
        route: route,
        focused: true,
        horizontal: horizontal,
        tintColor: activeTintColor
      })), React.createElement(Animated.View, {
        style: [styles.icon, {
          opacity: inactiveOpacity
        }]
      }, renderIcon({
        route: route,
        focused: false,
        horizontal: horizontal,
        tintColor: inactiveTintColor
      })));
    }
  }]);

  return TabBarIcon;
}(React.Component);

export { TabBarIcon as default };
var styles = StyleSheet.create({
  icon: {
    // We render the icon twice at the same position on top of each other:
    // active and inactive one, so we can fade between them:
    // Cover the whole iconContainer:
    position: 'absolute',
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
    // Workaround for react-native >= 0.54 layout bug
    minWidth: 25
  }
});